/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import { Input, Select, Form, Spin } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import DokanOrderCard from '../card/DokanOrderCard';
import propic from '../../assets/images/profileImage.svg';
import {
    createNewOrderNote,
    deleteOrderNote,
    fetchOrderNotes,
    handleOrderNoteInput,
} from '../../redux/orders/ordersActions';
import DokanIcons from '../icon/DokanIcons';

const { TextArea } = Input;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
function OrderNotes({ OrderId, orderStatus }) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchOrderNotes(OrderId));
    }, [OrderId, dispatch]);
    const { orderNotes, newCustomerNote, orderNoteStatus, noteLoader } = useSelector(
        (state) => state.orders
    );
    const handleNoteInput = (name, value, status) => {
        dispatch(handleOrderNoteInput({ name, value, status }));
    };
    const handleSubmit = (values) => {
        dispatch(createNewOrderNote(newCustomerNote, OrderId));
    };

    return (
        <>
            <div>
                <DokanOrderCard hasTitle Title="Order Note" hasDivider>
                    <div className="px-30px py-2 relative">
                        {/** start */}
                        <Spin spinning={noteLoader} indicator={antIcon} tip="order note loading">
                            <div className="grid grid-cols-12 gap-3 overflow-y-auto h-64">
                                {/** customer note 1 */}
                                {orderNotes?.map((item) => (
                                    <>
                                        <div key={item.id} />
                                        <>
                                            {item?.customer_note ? (
                                                <>
                                                    <div className="col-start-1 col-end-2">
                                                        <div className="h-12 w-12 rounded-full">
                                                            <img
                                                                src={propic}
                                                                alt={propic}
                                                                className="h-full w-full rounded-full"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="col-start-3 col-end-13 mb-12"
                                                        key={item.id}
                                                    >
                                                        <div className="flex flex-grow-6 gap-3 justify-start items-center">
                                                            <div className="flex-grow-5">
                                                                <div className="flex flex-col gap-3">
                                                                    <div className="font-semibold text-light_gray">
                                                                        Billal
                                                                    </div>
                                                                    <div className="bg-ash-one px-5 py-4 rounded-tr-lg rounded-br-lg rounded-bl-lg">
                                                                        {item.note}
                                                                    </div>
                                                                    <span className="text-right text-tertiary">
                                                                        4 days ago
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="-mr-5 cursor-pointer">
                                                                <button
                                                                    type="button"
                                                                    onClick={() =>
                                                                        dispatch(
                                                                            deleteOrderNote(
                                                                                OrderId,
                                                                                item.id
                                                                            )
                                                                        )
                                                                    }
                                                                    className="focus:outline-none"
                                                                >
                                                                    <DokanIcons icon="#trash" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    {/** customer note 2 (private note) */}

                                                    <div className="col-start-1 col-end-2">
                                                        <div className="h-12 w-12 rounded-full">
                                                            <img
                                                                src={propic}
                                                                alt={propic}
                                                                className="h-full w-full rounded-full"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="col-start-3 col-end-13 mb-12"
                                                        key={item.id}
                                                    >
                                                        <div className="flex flex-grow-6 gap-3 justify-start items-center">
                                                            <div className="flex-grow-5">
                                                                <div className="flex flex-col gap-3">
                                                                    <div className="font-semibold text-light_gray">
                                                                        Billal
                                                                    </div>
                                                                    <div className="bg-purple-semiLight px-5 py-4 rounded-tl-lg rounded-bl-lg rounded-br-lg">
                                                                        {item.note}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    </>
                                ))}
                            </div>
                            {/** end */}
                            <div className="grid grid-cols-12 gap-3 mt-3">
                                <div className="col-span-full">
                                    <div className="flex flex-col justify-end">
                                        <div className="w-24 text-tertiary">
                                            <Select
                                                bordered={false}
                                                defaultValue={newCustomerNote.customer_note}
                                                onChange={(value) =>
                                                    handleNoteInput(
                                                        'customer_note',
                                                        value,
                                                        orderStatus
                                                    )
                                                }
                                            >
                                                <Option value="customer_note">Customer Note</Option>
                                                <Option value="private_note">Private Note</Option>
                                            </Select>
                                        </div>
                                        <div>
                                            <TextArea
                                                showCount
                                                onChange={(e) => {
                                                    handleNoteInput(
                                                        'note',
                                                        e.target.value,
                                                        orderStatus
                                                    );
                                                }}
                                                placeholder="write here"
                                                autoSize={{
                                                    minRows: 9,
                                                    maxRows: 10,
                                                }}
                                                value={newCustomerNote.note}
                                            />
                                        </div>
                                        <span
                                            className={`${
                                                orderNoteStatus === 'success'
                                                    ? 'text-green'
                                                    : 'text-red'
                                            }`}
                                        >
                                            {orderNoteStatus.message}
                                        </span>

                                        <div className="py-8">
                                            <button
                                                type="button"
                                                onClick={handleSubmit}
                                                className="py-2 px-4 bg-button-secondary rounded-md text-white focus:outline-none"
                                            >
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Spin>
                    </div>
                </DokanOrderCard>
            </div>
        </>
    );
}

export default OrderNotes;
